import { api } from '../lib/axios'

export const getAllCoins = async () => {
  return api.get('/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false&locale=en')
}